var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "myCenter"
  }, [_c('Header'), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "selecttag"
  }, [_c('div', {
    staticClass: "taglist",
    class: {
      'active': _vm.currentIndex === 0
    },
    on: {
      "click": function click($event) {
        return _vm.selectTag(0, _vm.infor.blankLabelName);
      }
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_vm.infor.mallBlankImage ? _c('img', {
    attrs: {
      "src": _vm.infor.mallBlankImage.sourceUrl
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.infor.blankLabelName) + " ")]), _c('span', {
    on: {
      "click": _vm.showViewer
    }
  }, [_vm._v(" 详情 "), _c('i', {
    staticClass: "iconfont icongengduoxiangqing-copy"
  })]), _vm.currentIndex === 0 ? _c('i', {
    staticClass: "iconfont iconbianzu1 selecticon"
  }) : _vm._e()]), _c('div', {
    staticClass: "taglist",
    class: {
      'active': _vm.currentIndex === 1
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.selectTag(1, _vm.infor.colorLabelName);
      }
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_vm.infor.mallColorImage ? _c('img', {
    attrs: {
      "src": _vm.infor.mallColorImage.sourceUrl
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.infor.colorLabelName) + " ")]), _c('span', {
    on: {
      "click": _vm.showViewer
    }
  }, [_vm._v(" 详情 "), _c('i', {
    staticClass: "iconfont icongengduoxiangqing-copy"
  })]), _vm.currentIndex === 1 ? _c('i', {
    staticClass: "iconfont iconbianzu1 selecticon"
  }) : _vm._e()])]), _vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mobile,
      expression: "mobile"
    }],
    staticClass: "mobile",
    attrs: {
      "placeholder": "请填写正确的手机号，我们会和你取得联系",
      "maxlength": "11"
    },
    domProps: {
      "value": _vm.mobile
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.mobile = $event.target.value;
      }
    }
  }), _vm.currentIndex === 1 ? _c('h3', [_vm._v(" 颜色数量 "), _c('span', [_vm._v("（选填）:")])]) : _vm._e(), _vm.currentIndex === 1 ? _c('el-select', {
    staticClass: "colorselect",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, _vm._l(_vm.listData, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    });
  }), 1) : _vm._e(), _vm.currentIndex === 1 ? _c('h3', [_vm._v(" 打印内容 "), _c('span', [_vm._v("（选填）:")]), _c('em', [_vm._v("请上传清晰的打印内容")])]) : _vm._e(), _vm.currentIndex === 1 ? _c('div', {
    staticClass: "file"
  }, [_c('ul', _vm._l(_vm.fileList, function (item, index) {
    return _c('li', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.sourceUrl
      }
    }), _c('i', {
      staticClass: "iconfont iconguanbi2",
      on: {
        "click": function click($event) {
          return _vm.removefile(index);
        }
      }
    })]);
  }), 0), !_vm.maxpic ? _c('div', {
    staticClass: "inputfile"
  }, [_c('i', {
    staticClass: "iconfont iconzhaopian"
  }), _c('span', [_vm._v(_vm._s(_vm.fileList.length) + "/5")]), _c('input', {
    attrs: {
      "type": "file",
      "multiple": "multiple",
      "accept": ".png, .jpg"
    },
    on: {
      "change": _vm.uploadpic
    }
  })]) : _vm._e()]) : _vm._e(), _vm._m(1), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.remark,
      expression: "remark"
    }],
    staticClass: "remark",
    attrs: {
      "maxlength": "500"
    },
    domProps: {
      "value": _vm.remark
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.remark = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "btn"
  }, [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.$router.back();
      }
    }
  }, [_vm._v("上一步")]), _c('span', {
    on: {
      "click": _vm.next
    }
  }, [_vm._v("确认提交")])])], 1), _c('div', {
    directives: [{
      name: "viewer",
      rawName: "v-viewer",
      value: {
        movable: false
      },
      expression: "{movable: false}"
    }],
    ref: "images",
    staticClass: "images"
  }, _vm._l(_vm.detailsList, function (item) {
    return _c('img', {
      key: item.id,
      attrs: {
        "src": item.sourceUrl
      }
    });
  }), 0), _c('BackTop', {
    attrs: {
      "hasShopping": false
    }
  }), _c('Footer')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('h3', [_c('b', [_vm._v("*")]), _vm._v("手机号码 ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('h3', [_vm._v(" 问题描述 "), _c('span', [_vm._v("（选填）:")]), _c('em', [_vm._v("如有其他需求，请备注说明")])]);
}];
export { render, staticRenderFns };